/*
 * Accessibility patches for the Judge.me review widget on product pages. Judge.me renders (and re-renders)
 * its own markup, so these are applied idempotently from a MutationObserver:
 *   #556 Reviews / Questions switcher exposed as an ARIA tabs pattern
 *   #571 pagination controls named for what they do (next / last page), not just their page number
 *   #545 required fields in the "Write a review" (sentence) and "Ask a question" (note + asterisks) forms marked visibly
 */
(function () {
  if (window.__jdgmA11yInit) return;
  window.__jdgmA11yInit = true;

  var REQUIRED_NOTE = 'Fields marked * are required.';
  var tabListCount = 0;

  function enhanceTabs() {
    document.querySelectorAll('.jdgm-subtab').forEach(function (list) {
      var widget = list.parentElement;
      var tabs = Array.prototype.slice.call(list.querySelectorAll('.jdgm-subtab__name'));
      if (!widget || !tabs.length) return;

      if (!list.dataset.a11yTabs) {
        tabListCount += 1;
        list.dataset.a11yTabs = String(tabListCount);
        list.setAttribute('role', 'tablist');
        list.setAttribute('aria-label', 'Reviews and questions');

        list.addEventListener('keydown', function (event) {
          var current = Array.prototype.slice.call(list.querySelectorAll('.jdgm-subtab__name'));
          var index = current.indexOf(document.activeElement);
          if (index === -1) return;

          var next;
          if (event.key === 'ArrowRight') next = current[(index + 1) % current.length];
          else if (event.key === 'ArrowLeft') next = current[(index - 1 + current.length) % current.length];
          else if (event.key === 'Home') next = current[0];
          else if (event.key === 'End') next = current[current.length - 1];
          else return;

          event.preventDefault();
          next.focus();
          next.click();
        });

        new MutationObserver(syncTabState).observe(list, {
          attributes: true,
          attributeFilter: ['class'],
          subtree: true,
        });
      }

      var id = list.dataset.a11yTabs;
      var panels = {
        reviews: widget.querySelector('.jdgm-rev-widg__body'),
        questions: widget.querySelector('.jdgm-quest-widg__body'),
      };

      tabs.forEach(function (tab) {
        var name = tab.getAttribute('data-tabname');
        var tabId = 'jdgm-tab-' + name + '-' + id;
        var panel = panels[name];

        tab.id = tabId;
        tab.setAttribute('role', 'tab');
        if (panel) {
          panel.id = 'jdgm-tabpanel-' + name + '-' + id;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabId);
          tab.setAttribute('aria-controls', panel.id);
        }
      });

      syncTabState();
    });
  }

  function syncTabState() {
    document.querySelectorAll('.jdgm-subtab .jdgm-subtab__name').forEach(function (tab) {
      var selected = tab.classList.contains('jdgm--active');
      var value = selected ? 'true' : 'false';
      if (tab.getAttribute('aria-selected') !== value) tab.setAttribute('aria-selected', value);
      var tabindex = selected ? '0' : '-1';
      if (tab.getAttribute('tabindex') !== tabindex) tab.setAttribute('tabindex', tabindex);
    });
  }

  function labelPagination() {
    document.querySelectorAll('.jdgm-paginate a[data-page]').forEach(function (link) {
      var page = link.getAttribute('data-page');
      var label = null;

      if (link.classList.contains('jdgm-paginate__first-page')) label = 'First page';
      else if (link.classList.contains('jdgm-paginate__prev-page')) label = 'Previous page, page ' + page;
      else if (link.classList.contains('jdgm-paginate__next-page')) label = 'Next page, page ' + page;
      else if (link.classList.contains('jdgm-paginate__last-page')) label = 'Last page, page ' + page;

      if (label && link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
    });
  }

  // The review form hides its field labels (placeholders only), so asterisks on labels would never show there;
  // it gets a sentence naming the required fields instead. The question form keeps the note + asterisks.
  var REVIEW_FIELD_PHRASES = {
    reviewer_name: 'display name',
    reviewer_email: 'email address',
    score: 'a star rating',
    review_body: 'a review',
  };

  function joinPhrases(list) {
    if (list.length < 2) return list.join('');
    return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
  }

  function reviewRequiredNote(form) {
    var names = [];
    form.querySelectorAll('[required], [aria-required="true"]').forEach(function (field) {
      var key = field.name || (field.querySelector('input[name="score"]') ? 'score' : '');
      if (key && names.indexOf(key) === -1) names.push(key);
    });
    var phrases = [];
    for (var i = 0; i < names.length; i++) {
      if (!REVIEW_FIELD_PHRASES[names[i]]) return REQUIRED_NOTE;
      phrases.push(REVIEW_FIELD_PHRASES[names[i]]);
    }
    var sentence = joinPhrases(phrases) + (phrases.length === 1 ? ' is' : ' are') + ' required.';
    return sentence.charAt(0).toUpperCase() + sentence.slice(1);
  }

  function markRequiredFields() {
    document.querySelectorAll('.jdgm-form, .jdgm-question-form').forEach(function (form) {
      if (form.dataset.a11yRequired) return;

      var required = form.querySelectorAll('[required], [aria-required="true"]');
      if (!required.length) return;
      form.dataset.a11yRequired = 'true';

      var isReviewForm = form.classList.contains('jdgm-form');

      if (!isReviewForm) {
        required.forEach(function (field) {
          var label = field.id ? form.querySelector('label[for="' + field.id + '"]') : null;
          if (!label) {
            var group = field.closest('[class*="-fieldset"]');
            label = group && group.querySelector('label');
          }
          if (!label || label.querySelector('.jdgm-required-mark')) return;

          var mark = document.createElement('span');
          mark.className = 'jdgm-required-mark';
          mark.setAttribute('aria-hidden', 'true');
          mark.textContent = ' *';
          label.appendChild(mark);
        });
      }

      var note = document.createElement('p');
      note.className = 'jdgm-required-note';
      note.textContent = isReviewForm ? reviewRequiredNote(form) : REQUIRED_NOTE;
      form.insertBefore(note, form.firstChild);
    });
  }

  function run() {
    enhanceTabs();
    labelPagination();
    markRequiredFields();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  function init() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
